export { default } from "./SchemaMarkup.jsx";
